interface XaviorLoaderProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: { container: 'w-8 h-8', logo: 'w-6 h-6 text-xs' },
  md: { container: 'w-12 h-12', logo: 'w-9 h-9 text-base' },
  lg: { container: 'w-16 h-16', logo: 'w-12 h-12 text-xl' },
};

export function XaviorLoader({ size = 'md', className = '' }: XaviorLoaderProps) {
  const classes = sizeClasses[size];

  return (
    <div className={`flex items-center justify-center ${classes.container} ${className}`}>
      <div
        className={`${classes.logo} bg-sky-500 rounded-full flex items-center justify-center animate-xavior-pulse`}
      >
        <span className="text-white font-bold">X</span>
      </div>
    </div>
  );
}
